import { FerzUI } from '../core/FerzUI';

export class ThemeManager {
  private root: HTMLElement;

  constructor(_fz: FerzUI) {
    this.root = document.documentElement;
  }

  public setTheme(themeName: string): void {
    this.root.setAttribute('data-theme', themeName);
    localStorage.setItem('theme', themeName);
  }

  public setVariable(name: string, value: string): void {
    this.root.style.setProperty(`--fz-c-${name}`, value);
  }

  public setDirection(dir: 'ltr' | 'rtl'): void {
    this.root.setAttribute('dir', dir);
    localStorage.setItem('dir', dir);
  }

  public setRadius(value: string): void {
    this.root.style.setProperty('--fz-radius-base', value);
  }

  public reset(): void {
    this.root.removeAttribute('style');
    this.root.removeAttribute('data-theme');
    this.root.removeAttribute('dir');
    localStorage.removeItem('theme');
    localStorage.removeItem('dir');
  }
}
